import InstrumentTableItem from './InstrumentTableItem';

export default InstrumentTableItem;
